var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tracker"}},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_vm._v("\n     Hier komen dan kekke grafiekjes over trackers?\n    ")])])])
}]

export { render, staticRenderFns }